export default __webpack_public_path__ + "static/media/13.88d66557.jpg";